export const TOPIC_VALIDATION = {
  MIN_LENGTH: 3,
  MAX_LENGTH: 100
} as const

export const DEVICE_LABELS = {
  NO_CAMERA: 'Aucune caméra disponible',
  NO_MICROPHONE: 'Aucun micro disponible',
  NO_SPEAKER: 'Aucun haut-parleur disponible',
  CAMERA_DISABLED: 'Caméra désactivée',
  MICROPHONE_MUTED: 'Micro coupé'
} as const

export const PERMISSIONS_HELP_URL =
  'https://help.myjobglasses.com/fr/articles/515408-autoriser-l-acces-aux-peripheriques-pour-rejoindre-la-visio-integree'
